import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ROLES } from "src/constants";
import orderService from "src/_services/orderService";

export const getCompletedOrderCount = createAsyncThunk(
    'ordersCount/getCompletedOrderCount',
    async () => {
        const response = await orderService.getCompletedOrderCount();
        return response.data.body
    }
);
export const updateCompletedOrderCount = createAsyncThunk(
    'ordersCount/updateCompletedOrderCount',
    async (id) => {
        const response = await orderService.updateCompletedOrderCount(id);
        return response.data.body
    }
);
const slice = createSlice({
    name: "ordersCount",
    initialState: {
        loading: false,
        actionLoading: false,
        newFailedOrdersCount: 0,
        newSuccessfulOrdersCount: 0
    },
    reducers: {

    },
    extraReducers: {
        [getCompletedOrderCount.pending]: (state) => {
            state.loading = true
        },
        [getCompletedOrderCount.fulfilled]: (state, { payload }) => {
            state.newFailedOrdersCount = payload.newFailedOrdersCount
            state.newSuccessfulOrdersCount = payload.newSuccessfulOrdersCount
            state.loading = false
        },
        [getCompletedOrderCount.rejected]: (state) => {
            state.loading = false
        },
        //==========Update completed orders count===========
        [updateCompletedOrderCount.pending]: (state) => {
            state.actionLoading = true
        },
        [updateCompletedOrderCount.fulfilled]: (state) => {
            state.actionLoading = false
        },
        [updateCompletedOrderCount.rejected]: (state, action) => {
            state.actionLoading = false
            state.errorMessage = action.error?.message ? action.error.message : 'Something went wrong please try again'
        },
    },
});


// export const {
//     setConnectionsLoading
// } = slice.actions;



export default slice.reducer;
